export const CollectionInViewSkeleton = () => {
  return (
    <div className="flex w-[200px] flex-shrink-0 animate-pulse flex-col rounded-[10px] bg-white p-4 shadow-md dark:bg-white/[8%]">
      <div className="mb-[5px] h-6 w-6 rounded bg-black/10 dark:bg-white/10" />

      <div className="mb-[5px] h-4 w-2/3 rounded bg-black/10 dark:bg-white/10" />

      <div className="h-2.5 w-1/3 rounded bg-black/10 dark:bg-white/10" />
    </div>
  );
};
